import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Panel, DefaultButton } from '@bingads-webui-react/fabric-control';
import { AdPlacementsGridPreview } from './ad-placements-grid-preview';
import { getPanelStyle } from './ad-placements-grid-preview-style';

export function AdPlacementsGridPreviewPanel({
  isOpen,
  onDismiss,
  className,
  cellsNumberPerRow,
  totalCount,
  onRenderCell,
  cellHeight,
}) {
  const i18n = useContext(I18nContext);
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <DefaultButton onClick={onDismiss}>{i18n.getString(_TL_('Close'))}</DefaultButton>
      </div>
    ),
    [i18n, onDismiss]
  );

  return (
    <Panel
      className={classnames('ad-placements-grid-panel', className)}
      headerText={i18n.getString(_TL_('View example placements'))}
      isOpen={isOpen}
      onDismiss={onDismiss}
      closeButtonAriaLabel={i18n.getString(_TL_('Close'))}
      onRenderFooterContent={onRenderFooterContent}
      styles={_.pick(getPanelStyle(), 'footer', 'commands')}
      isFooterAtBottom
    >
      <AdPlacementsGridPreview
        cellsNumberPerRow={cellsNumberPerRow}
        totalCount={totalCount}
        onRenderCell={onRenderCell}
        cellHeight={cellHeight}
      />
    </Panel>
  );
}

AdPlacementsGridPreviewPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  cellsNumberPerRow: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onRenderCell: PropTypes.func.isRequired,
  className: PropTypes.string,
  cellHeight: PropTypes.number,
};

AdPlacementsGridPreviewPanel.defaultProps = {
  className: '',
  cellHeight: 482,
};
